import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import coursesData from "../data/coursesData";
import { useTranslation } from 'react-i18next';

const CoursesPortal = () => {
  const { t } = useTranslation();
  const { courseName, coursesClassTitle } = useParams();
  const formattedCourseName = courseName.replace(/-/g, ' ');
  const formattedCoursesClassTitle = coursesClassTitle.replace(/-/g, ' ');
  const [openUnit, setOpenUnit] = useState(null);
  const [showPopup, setShowPopup] = useState(false); // حالة للتحكم في ظهور النافذة المنبثقة
  const [examPath, setExamPath] = useState(''); // حالة لتخزين المسار الخاص بالامتحان

  const course = coursesData.find(el => el.coursesName === formattedCourseName);
  if (!course) {
    return <div>Course not found</div>;
  }

  const courseClass = course.coursesClasses.find(cc => cc.coursesClassesTitle === formattedCoursesClassTitle);
  if (!courseClass) {
    return <div>Course class not found</div>;
  }

  const toggleUnit = (index) => {
    setOpenUnit(openUnit === index ? null : index);
  };

  // دالة لفتح النافذة المنبثقة وتخزين المسار
  const handleStartExamClick = (path) => {
    setExamPath(path);
    setShowPopup(true);
  };

  // دالة لإغلاق النافذة المنبثقة
  const handleClosePopup = () => {
    setShowPopup(false);
    setExamPath('');
  };

  return (
    <>
      <section className="landing-courses-page">
        <div className="container h-full flex flex-col justify-center gap-[5px]">
          <div className="text-[30px] font-bold text-[#09778E] capitalize">{formattedCourseName} - {formattedCoursesClassTitle}</div>
          <div className="flex items-center gap-[5px] font-bold capitalize">
            <Link to="/">{t("Home")}</Link>
            -
            <div className="text-[#09778E]">{formattedCourseName}</div>
          </div>
        </div>
      </section>

      <section className="relative py-[40px]">
        <div className="container flex flex-col gap-[20px]">
          <div className="bord text-[20px] font-bold capitalize text-[#09778e] border-l-8 border-[#09778e] pl-2.5">
            {t("Choose the exam you want. You can describe the units of the subject in")} {formattedCoursesClassTitle}
          </div>
          <div className='flex flex-col gap-[10px]'>
            {courseClass.semesterUnits.map((unit, index) => (
              <div key={index} className="mb-4">
                <div onClick={() => toggleUnit(index)} className="cursor-pointer bg-[#09778E] text-white p-3 rounded-md mb-2">
                  <h2 className="text-lg font-bold">{unit.semesterUnitsName}</h2>
                </div>
                <div className={`overflow-hidden transition-all duration-500 ${openUnit === index ? "max-h-[1000px] py-3" : "max-h-0 py-0"}`}>
                  <ul>
                    {unit.lessonName.map((lesson, lessonIndex) => {
                      const examPath = `/${courseName}/${coursesClassTitle}/${unit.semesterUnitsName.replace(/ /g, '-')}/${lesson.classesName.replace(/ /g, '-')}`;
                      return (
                        <li key={lessonIndex} className="f-col bg-gray-100 p-[17px] rounded-md my-2 flex items-center justify-between">
                          <div className='font-bold flex items-center gap-[7px]'>
                            <span className='w-[15px] h-[15px] rounded-full bg-[#A31D1C]'></span>
                            <h3>{lesson.classesName}</h3>
                            <div>||</div>
                            <div className='text-[#A31D1C] capitalize'>{lesson.questions.length} {t("questions")}</div>
                          </div>
                          <button
                            onClick={() => handleStartExamClick(examPath)}
                            className="bg-[#09778e] py-[10px] px-[30px] text-white rounded-[4px] font-bold capitalize"
                          >
                            {t("Start Exam")}
                          </button>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>

        {showPopup && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white p-8 rounded-md shadow-lg relative flex flex-col gap-[25px]">
              <h2 className="text-xl font-bold mb-4 text-center text-[#09778e] capitalize w-[60%] mx-auto">{t("Before entering the exam, please select the type of exam you want:")}</h2>
              <div className="flex justify-center gap-4">
                <Link
                  to={examPath}
                  className="bg-[#09778e] py-[10px] px-[30px] text-white rounded-[4px] font-bold capitalize"
                  onClick={handleClosePopup}
                >
                  {t("Interactive Exam")}
                </Link>
                <Link
                  to={examPath}
                  className="bg-[#09778e] py-[10px] px-[30px] text-white rounded-[4px] font-bold capitalize"
                  onClick={handleClosePopup}
                >
                  {t("Regular Exam")}
                </Link>
              </div>
              <button
                onClick={handleClosePopup}
                className="absolute top-[1.5rem] right-[1.5rem] bg-[#A31D1C] w-[30px] h-[30px] rounded-full text-white font-bold"
              >
                ✕
              </button>
            </div>
          </div>
        )}
      </section>
    </>
  );
};

export default CoursesPortal;